import React from 'react';

import StructureMapping from 'Flow2/util/StructureMapping.js';
import { format } from 'date-fns';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Input from 'Flow2/components/UI/Input/Input';
import Checkbox from 'Flow2/components/UI/Checkbox/Checkbox';
import TagsTree from 'Flow2/components/TagsTree/TagTree';
import AddList from 'Flow2/components/AddList/AddList';
import UserList from 'Flow2/components/SelectionList/UserList';
import Countries from 'Flow2/components/CustomCollections/CustomDataJson/countries.json';
import { CONTENT_DATA } from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataConfig";

import RoomUserList from 'Flow2/components/AddList/RoomUserList';

import MediaFile from 'Flow2/util/MediaFile.js';

import { FormattedMessage } from 'react-intl';

import { dateFormat, DATE_FORMAT } from 'Flow2/util/helperFunctions.js';
import * as Room from 'Flow2/util/Room.js';
import * as classes from 'Flow2/components/CustomCollections/CustomStyled/CustomHelper.module.scss';

//const DATE_FORMAT = "dd.MM.yyyy";
//const LOCAL_DATE = "de-DE";

const Datefield = (props) => {
    let theDate = "";
    if (props.date) {
        theDate = props.date;
    }
    const date = new Date(theDate.split(' ')[0]);
    const dateString = date.toLocaleDateString('de-DE', { 'year': 'numeric', 'month': '2-digit', 'day': '2-digit' });

    if (dateString == 'Invalid Date') {
        return (<div className={classes.cmdatapicker}><DatePicker
            dateFormat={props.format}
            onChange={(selectedDate) => props.change(selectedDate, props.id)}
            isClearable={true} /></div>);
    }

    return (<div className={classes.cmdatapicker}><DatePicker
        dateFormat={props.format}
        selected={new Date(theDate.split(' ')[0])}
        onChange={(selectedDate) => props.change(selectedDate, props.id)}
        isClearable={true} /></div>);
}

class MetadataElementHelper {

    static createElement(configType, key, value) {
        let obj = StructureMapping.getField(configType, key);

        if (!obj) {
            return null;
        }

        let element = {
            id: key,
            name: obj.name,
            intl: StructureMapping.getIntl(obj),
            order: StructureMapping.getOrder(obj),
            value: value,
            field: "",
            obj: obj
        };

        return element;
    }

    static createDisplayField(element, context) {
        if (!element || !element.obj || !element.value) {
            return "";
        }

        switch (StructureMapping.getType(element.obj)) {
            case 'checkbox':
            case 'dropdown':
            case 'radio':
                // prevent null exception
                const type = StructureMapping.getType(element.obj);
                let values = element.value.split(';');
                const options = StructureMapping.getOptions(element.obj);

                // make unique array
                values = [...new Set(values)];

                for (let i in values) {
                    let optionValue = options[values[i]]
                    values[i] = (optionValue !== undefined) ? <FormattedMessage id={element.intl + "." + type + "." + values[i]} key={element.intl + "." + type + "." + values[i]} defaultMessage={optionValue} children={(formattedMessage) => <>{formattedMessage}<br /></>} /> : "";
                }

                return values;
            case 'textfield':
            case 'text':
                if (StructureMapping.isDatefield(element.obj)) {
                    /*try {
                        const date = new Date(element.value.split(' ')[0]);
                        const dateString = date.toLocaleDateString('de-DE', { 'year': 'numeric', 'month': '2-digit', 'day': '2-digit' });;
                        const dateFormat = context.props.config.dateFormat || DATE_FORMAT;

                        if (dateString == 'Invalid Date') {
                            return "-";
                        }
                        return format(date, dateFormat.toUpperCase());
                    } catch (e) {
                        console.log(e);
                    }*/
                    return dateFormat(element.value.split(' ')[0], context.props.config.dateFormat);
                }
                // calc MB from B
                if (element.id === 'groesse') {
                    return MediaFile.formatBytes(element.value);
                }

                return (<span>{element.value.replace(/;/g, '; ')}</span>);
            case 'link':
                return (<span><a href={element.value} title={element.value} target="_blank">{element.value}</a></span>);
            case 'tagtree':
                if (!context) {
                    return "";
                }

                const tagtree = StructureMapping.getTagTree(element.obj);
                const referenceIds = StructureMapping.getTagTreeReferenceIds(element.obj);
                const value = context.getValue(referenceIds);

                if (value !== null) {
                    const ids = value.split(';');
                    return <TagsTree
                        data={tagtree}
                        preSelectedTags={ids}
                        lang={context.state.lang}
                        defaultLang={context.props.config.tagsTreeDefaultLanguage}
                        readonly={true} />
                }

                // set empty pre selected tags to reset store
                return <TagsTree
                    data={tagtree}
                    preSelectedTags={[]}
                    lang={context.state.lang}
                    defaultLang={context.props.config.tagsTreeDefaultLanguage}
                    readonly={true} />
            case 'addlist':
                const list = element.value.split(';');
                return <AddList
                    data={list} />
            case 'datetime':
                /*try {
                    const datetime = element.value.split(' ');
                    const date = new Date(datetime[0]);
                    const dateString = date.toLocaleDateString('de-DE', { 'year': 'numeric', 'month': '2-digit', 'day': '2-digit' });
                    const dateFormat = context.props.config.dateFormat || DATE_FORMAT;

                    if (dateString == 'Invalid Date') {
                        return "-";
                    }
                    const theDate = dateFormat(datetime[0], context.props.config.dateFormat);

                    return theDate + ((datetime.length > 1) ? " " + datetime[1] : "");
                } catch (e) {
                    console.log(e);
                }*/
                const datetime = element.value.split(' ');
                const theDate = dateFormat(datetime[0], context.props.config.dateFormat);
                if (theDate) {
                    return theDate + ((datetime.length > 1) ? " " + datetime[1] : "");
                }
                return "";
            case 'userlist':
                const params = StructureMapping.getUserList(element.obj);
                return <UserList
                    value={element.value}
                    {...params} />
            case 'yearlist':
                const years = element.value.split(';');
                return <AddList
                    data={years}
                    style="tab" />

            case 'countrylist':
                if (!context) {
                    return "";
                }

                const countries = (element.value) ? element.value.split(';') : [];

                return <AddList
                    data={countries}
                    list={Countries}
                    valueField="ID"
                    labelField={context.state.lang.toUpperCase()}
                    style="tab" />


            case 'contentlist':
                if (!context) {
                    return "";
                }

                const contents = (element.value) ? element.value.split(';') : [];

                return <AddList
                    data={contents}
                    list={CONTENT_DATA}
                    valueField="ID"
                    labelField={context.state.lang.toUpperCase()}
                    style="tab" />


            case 'roommember':
                const member = Room.getRoomMember(element.value);

                return <RoomUserList
                    data={member.members}
                    pwd={member.pwd}
                    singlePassword={StructureMapping.isSinglePassword(element.obj)} />
            default:
                return element.value;
        }
    }

    static createEditField(element, context) {
        if (!element || !element.obj) {
            return "";
        }
        switch (StructureMapping.getType(element.obj)) {
            case 'checkbox':
                const checkboxOptions = StructureMapping.getOptions(element.obj);
                let inputs = [];

                for (let key in checkboxOptions) {
                    inputs.push(<Checkbox
                        key={key}
                        value={key}
                        id={element.intl + ".checkbox." + key.replace(/ /g, '')}
                        label={checkboxOptions[key]}
                        // ****************************************************** //
                        // ************* Quick fix please check ***************** //
                        checked={(context.structures && context.structures.checkbox[element.id][key]) ? "checked" : ""}
                        // ****************************************************** //
                        changed={() => context.checkboxChangeHandler(element.id, key)} />);
                }
                return inputs;
            case 'dropdown':
                const optionList = { options: MetadataElementHelper.createSelectOptionList(element) };
                return <Input
                    key={element.id}
                    value={(element.value !== null) ? element.value : ""}
                    elementType="select_intl"
                    elementConfig={optionList}
                    changed={(event) => context.inputChangedHandler(event.target.value, element.id)} />
            case 'radio':
                const radioOptions = { options: MetadataElementHelper.createSelectOptionList(element) };
                return <Input
                    key={element.id}
                    name={element.id}
                    value={(element.value !== null) ? element.value : ""}
                    elementType="radio_intl"
                    elementConfig={radioOptions}
                    changed={(event) => context.inputChangedHandler(event.target.value, element.id)} />
            case 'textfield':
                return <Input
                    key={element.id}
                    value={(element.value) ? element.value.replace(/;/g, '; ') : ""}
                    elementType="textarea"
                    changed={(event) => context.inputChangedHandler(event.target.value, element.id)} />
            case 'text':
                if (StructureMapping.isDatefield(element.obj)) {
                    return <Datefield
                        date={element.value}
                        id={element.id}
                        format={context.props.config.dateFormat || DATE_FORMAT}
                        change={context.dateChangedHandler} />
                }

                if (StructureMapping.isTimefield(element.obj)) {
                    return <Input
                        key={element.id}
                        value={(element.value) ? element.value.replace(/;/g, '; ') : ""}
                        elementConfig={{ type: 'time', step: 2 }}
                        changed={(event) => context.inputChangedHandler(event.target.value, element.id)} />
                }

                return <Input
                    key={element.id}
                    value={(element.value) ? element.value.replace(/;/g, '; ') : ""}
                    elementConfig={{ type: 'text', placeholder: StructureMapping.hasPlaceholder(element.obj) || "" }}
                    changed={(event) => context.inputChangedHandler(event.target.value, element.id)} />
            case 'link':
                return <Input
                    key={element.id}
                    value={(element.value) ? element.value : ""}
                    elementConfig={{ type: 'text' }}
                    changed={(event) => context.inputChangedHandler(event.target.value, element.id)} />
            case 'tagtree':
                if (!context) {
                    return "";
                }
                const tagtree = StructureMapping.getTagTree(element.obj);
                const referenceIds = StructureMapping.getTagTreeReferenceIds(element.obj);
                const value = context.getValue(referenceIds);
                if (value !== null) {
                    const ids = value.split(';');
                    return <TagsTree
                        data={tagtree}
                        preSelectedTags={ids}
                        field={element.id}
                        refField={referenceIds}
                        addHandler={context.tagTreeAddHandler}
                        removeHandler={context.tagTreeRemoveHandler}
                        lang={context.state.lang}
                        defaultLang={context.props.config.tagsTreeDefaultLanguage} />
                }

                // set empty pre selected tags to reset store
                return <TagsTree
                    data={tagtree}
                    preSelectedTags={[]}
                    field={element.id}
                    refField={referenceIds}
                    addHandler={context.tagTreeAddHandler}
                    removeHandler={context.tagTreeRemoveHandler}
                    lang={context.state.lang}
                    defaultLang={context.props.config.tagsTreeDefaultLanguage} />
            case 'addlist':
                const list = (element.value) ? element.value.split(';') : "";

                return <AddList
                    data={list}
                    add={(input) => { context.addListHandler(input, element.id) }}
                    remove={(index) => { context.removeListHandler(index, element.id) }} />
            case 'datetime':
                let date = "";
                let time = "00:00";
                let datetime = [];
                let out = [];

                if (element.value) {
                    datetime = element.value.split(' ');
                    date = datetime[0];
                    time = datetime[1];
                }

                out.push(<Datefield
                    key={"date" + element.id}
                    date={date}
                    id={element.id}
                    format={context.props.config.dateFormat || DATE_FORMAT}
                    change={(value) => {
                        if (value !== null) {
                            let dateString = format(value, 'YYYY-MM-DD');
                            context.inputChangedHandler(dateString + " " + time, element.id);
                        }
                    }} />);

                out.push(<Input
                    key={"time" + element.id}
                    value={time}
                    elementConfig={{ type: 'time' }}
                    changed={(event) => {
                        context.inputChangedHandler(date + " " + event.target.value, element.id);
                    }} />);

                return out;
            case 'userlist':
                const params = StructureMapping.getUserList(element.obj);
                return <UserList
                    value={element.value}
                    add={(input) => { context.inputChangedHandler(input, element.id) }}
                    {...params} />
            case 'yearlist':
                const years = (element.value) ? element.value.split(';') : [];

                const values = [];
                let dateNow = new Date();
                let maxYear = dateNow.getFullYear();
                if (dateNow.getMonth() > 10) maxYear += 1;
                for (let i = 1945; i <= maxYear; i++) {
                    values.push({ year: i + "" });
                }
                return <AddList
                    data={years}
                    list={values}
                    valueField="year"
                    labelField="year"
                    add={(input) => {
                        years.push(input);
                        context.inputChangedHandler(years.join(';'), element.id);
                    }
                    }
                    remove={(index) => {
                        years.splice(index, 1);
                        context.inputChangedHandler(years.join(';'), element.id);
                    }
                    }
                    style="tab" />
            case 'countrylist':
                const countries = (element.value) ? element.value.split(';') : [];

                return <AddList
                    data={countries}
                    list={Countries}
                    valueField="ID"
                    labelField={context.state.lang.toUpperCase()}
                    add={(input) => {
                        countries.push(input);
                        context.inputChangedHandler(countries.join(';'), element.id);
                    }
                    }
                    remove={(index) => {
                        countries.splice(index, 1);
                        context.inputChangedHandler(countries.join(';'), element.id);
                    }
                    }
                    style="tab" />

            case 'contentlist':
                const contents = (element.value) ? element.value.split(';') : [];

                return <AddList
                    data={contents}
                    list={CONTENT_DATA}
                    valueField="ID"
                    labelField={context.state.lang.toUpperCase()}
                    add={(input) => {
                        contents.push(input);
                        context.inputChangedHandler(contents.join(';'), element.id);
                    }
                    }
                    remove={(index) => {
                        contents.splice(index, 1);
                        context.inputChangedHandler(contents.join(';'), element.id);
                    }
                    }
                    style="tab" />
            case 'roommember':
                const member = Room.getRoomMember(element.value);

                return <RoomUserList
                    data={member.members}
                    pwd={member.pwd}
                    add={(value) => { context.inputChangedHandler(value, element.id); }}
                    remove={(value) => { context.inputChangedHandler(value, element.id); }}
                    singlePassword={StructureMapping.isSinglePassword(element.obj)} />
            default:
                return element.value;
        }
    }

    static createSelectOptionList(element) {
        const options = StructureMapping.getOptions(element.obj);
        let inputs = [];

        for (let key in options) {
            inputs.push({ value: key, id: element.intl + ".dropdown." + key, displayValue: options[key] });
        }

        return inputs;
    }

    static isConditionSuccess(conditions, elements) {
        for (let key in conditions) {
            if (elements.hasOwnProperty(key)) {
                if ((typeof elements[key] === 'string') && elements[key].indexOf(conditions[key]) === -1) {
                    return false;
                }
            }
        }
        return true;
    }
}

export default MetadataElementHelper;
